import React from 'react';

export default function IconSelect({ icon: IconComp, value, onChange, children }) {
  return (
    <div className="icon-select">
      <span className="icon-select-icon"><IconComp /></span>
      <select value={value} onChange={onChange}>
        {children}
      </select>
    </div>
  );
}
